<script lang="ts" setup>
const config = useRuntimeConfig();

useHead({
  title: "Align",
  meta: [
    { charset: "utf-8" },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,minimum-scale=1,user-scalable=no",
    },
    {
      name: "description",
      content: config.public.description || "",
    },
    { name: "google", content: "notranslate" },
  ],
  link: [{ rel: "icon", type: "image/x-icon", href: "/favicon.svg" }],
});
</script>
<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
